import {
    put, call, all, takeLatest, select
} from 'redux-saga/effects';
import { defaultSaga, getActions } from '../utils';

import * as constants from './constants';
import * as actions from './actions';
import * as api from './api';
import converter from './converter';

export default function* rootSaga() {
    yield all([
        yield takeLatest(
            constants.getCalculatorsSoilComposition.toString(),
            defaultSaga({
                constants: constants.getCalculatorsSoilComposition,
                api: api.getCalculatorsSoilComposition
            })
        ),
        yield takeLatest(
            constants.getCalculatorsSoilCompositionItem.toString(),
            defaultSaga({
                constants: constants.getCalculatorsSoilCompositionItem,
                api: api.getCalculatorsSoilCompositionItem
            })
        )
    ]);
}